export interface JoditVariableToken {
  id: string;
  label: string;
}

/**
 * JODIT Variable Utilities
 *
 * Utility functions for working with template variables in JODIT editor. Variables are inserted as plain text
 * placeholders via the side panel.
 *
 * Format: {{variable-id}}
 *
 * @example
 *   ```typescript
 *   // Extract variables from HTML content
 *   const html = '<p>Hello {{first_name}}, your email is {{email}}</p>';
 *   const vars = extractVariablesFromHTML(html);
 *   // Result: [{id: 'first_name', label: 'first_name'}, {id: 'email', label: 'email'}]
 *   ```;
 */

/**
 * Parse HTML and extract variables
 *
 * @param html - HTML string to parse
 * @returns Array of found variable IDs (unique)
 */
export function extractVariablesFromHTML(html: string): JoditVariableToken[] {
  // Match {{variable-id}} patterns
  const variablePattern = /\{\{([^}]+)\}\}/g;
  const variables: JoditVariableToken[] = [];
  const seen = new Set<string>();

  let match;
  while ((match = variablePattern.exec(html)) !== null) {
    const id = match[1]?.trim();
    if (id && !seen.has(id)) {
      seen.add(id);
      variables.push({
        id,
        label: id, // Only ID available from plain text
      });
    }
  }

  return variables;
}
